import React from "react";
import { AppList } from "components/list/AppList";
import { Box } from "@material-ui/core";

import { stylesForColorInheritInList } from "../../../components/_helpers/useStyles";
import { ScrollingWrapper } from "../../../components/ScrollingWrapper";
import { useGridUserDataGlobalFiltersContext } from "contexts/GridUserDataGlobalFiltersProvider";
import { useTerminalsContext } from "contexts/TerminalsProvider";
import { useAsyncColumnsStorage } from "utils/hooks/useAsyncColumnsStorage";
import { StorageTransactionsFilters } from "./ListFilters";
import { StorageTransactionsActions } from "./Actions";
import { StorageTransactionsDatagrid } from "./Fields";

const defaultSort = { field: "id", order: "DESC" };


export const StorageTransactionsList = (props) => {
	const { data: globalFilters = {}, isLoading } = useGridUserDataGlobalFiltersContext();
	const { data: terminals } = useTerminalsContext();
	const columnsAsyncStorage = useAsyncColumnsStorage("storage-transactions-columns");
	const classes = stylesForColorInheritInList();

	if (isLoading || !columnsAsyncStorage.isLoaded) return null;

	const currentFilters = { storage_context_terminal_id: globalFilters?.terminal_id };
	const t = (source) => `resources.storage-transactions.fields.${source}`;

	return (
		<AppList
			{...props}
			exporter={false}
			bulkActionButtons={false}
			classes={classes}
			sort={defaultSort}
			actions={<StorageTransactionsActions />}
			filters={<StorageTransactionsFilters />}
			filterDefaultValues={currentFilters}
			filter={currentFilters}
		>
			<Box sx={{ maxHeight: "calc(100vh - 230px)", overflow: "auto" }}>
				<ScrollingWrapper>
					<StorageTransactionsDatagrid terminals={terminals} t={t} columnsAsyncStorage={columnsAsyncStorage} />
				</ScrollingWrapper>
			</Box>
		</AppList>
	);
};
